/**
 * TipoVeiculo
 * @author gil
 */
export enum TipoVeiculo {
  BITREM = 'BITREM',
  BITRENZAO = 'BITRENZÃO (9 EIXOS)',
  BITRUCK = 'BI-TRUCK',
  CARRETA = 'CARRETA',
  CARRETA_LS = 'CARRETA LS',
  MOTO = 'MOTO',
  RODOTREM = 'RODOTREM',
  SO_CAVALO_MECANICO_4X2 = 'SÓ CAVALO MECANICO (4X2)',
  SO_CAVALO_MECANICO_LS = 'SÓ CAVALO MECANICO LS',
  TOCO = 'TOCO',
  TOCO_3_4 = 'TOCO 3/4',
  TRITREM = 'TRITREM',
  TRUCK = 'TRUCK',
  UTILITARIO = 'UTILITÁRIO',
  VAN = 'VAN',
  VUC_HR = 'VUC / HR',
  OUTROS = 'OUTROS',
}
